import QuestionNoItem, { QuestionNoItemProps } from './QuestionNoItem';

export default QuestionNoItem;
export type { QuestionNoItemProps as ExamNoItemProps };
